import React from 'react';
import useLocalStorage from '@/hooks/useLocalStorage';
import useReadLocalStorage from '@/hooks/useReadLocalStorage';
import Dropdown from '@/components/dropdown/Dropdown';
import PositionPanelStyled from './PositionPanel.styled';
import { PanelTypes } from '@/types/Panel.types';
import { ToolbarPositions } from '@/components/draggableToolbar/DraggableToolbar.types';

interface PositionPanelProps {
  onClose: () => void;
}

const getDefaultPosition = (position: string) => {
  if (position === 'TopLeft' || position === 'BottomLeft') return position;
  if (position === 'BottomRight') return 'BottomLeft';
  if (position === 'TopRight') return 'TopLeft';
  return position;
};

const PositionPanel = ({ onClose }: PositionPanelProps) => {
  const pos = useReadLocalStorage('contensis-blocks-preview-toolbar-position') as string;
  const [, setPosition] = useLocalStorage('contensis-blocks-preview-toolbar-position', pos);

  return (
    <PositionPanelStyled data-position={pos}>
      <Dropdown
        id={PanelTypes.Position}
        defaultValue={getDefaultPosition(pos)}
        onClose={onClose}
        onDropdownSelect={(evtValue: string) => setPosition(evtValue)}
        options={[
          {
            id: ToolbarPositions.TopLeft,
            label: 'Position top',
          },
          {
            id: ToolbarPositions.BottomLeft,
            label: 'Position bottom',
          },
        ]}
      />
    </PositionPanelStyled>
  );
};

export default PositionPanel;
